// 通用展示格式化辅助。

// 中文短位：< 1万 原值；1万 ~ 9999万 用「万」；>= 1亿 用「亿」；>= 1兆 用「兆」。
// 保留 1 位小数，再剥掉尾随 .0，避免 "12.0 万" 这种冗余写法。
function trimZero(s: string): string {
  return s.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
}

export function compactNumber(n: number | undefined | null): string {
  if (n === undefined || n === null || Number.isNaN(n)) return "";
  const abs = Math.abs(n);
  if (abs < 10_000) return Number.isInteger(n) ? String(n) : trimZero(n.toFixed(2));
  if (abs < 100_000_000) return `${trimZero((n / 10_000).toFixed(1))}万`;
  if (abs < 1_000_000_000_000) {
    return `${trimZero((n / 100_000_000).toFixed(2))}亿`;
  }
  return `${trimZero((n / 1_000_000_000_000).toFixed(2))}兆`;
}

export function formatCombatPower(n: number | undefined | null): string {
  return compactNumber(n);
}

export function formatCombatPowerRank(n: number | undefined | null): string {
  if (n === undefined || n === null || !Number.isFinite(n) || n <= 0) return "";
  return `第${Math.floor(n)}名`;
}

export function formatDurationSec(sec: number | undefined | null): string {
  if (!sec || sec <= 0) return "0s";
  if (sec < 60) return `${sec.toFixed(0)}s`;
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec - m * 60);
  if (m < 60) return s > 0 ? `${m}m${s}s` : `${m}m`;
  const h = Math.floor(m / 60);
  const mm = m - h * 60;
  return mm > 0 ? `${h}h${mm}m` : `${h}h`;
}

export function killsPerMin(
  kills: number,
  dwellSec: number | undefined | null,
): string {
  if (!dwellSec || dwellSec <= 0) return "—";
  const kpm = (kills / dwellSec) * 60;
  return kpm.toFixed(1);
}

export function formatMs(ms: number | undefined | null): string {
  if (!ms) return "";
  try {
    const date = new Date(ms);
    if (!Number.isFinite(date.getTime())) return String(ms);
    return `${formatLocalDateTime(date)} ${formatGMTOffset(date)}`;
  } catch {
    return String(ms);
  }
}

function formatLocalDateTime(date: Date): string {
  const y = date.getFullYear();
  const m = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  const hh = pad2(date.getHours());
  const mm = pad2(date.getMinutes());
  const ss = pad2(date.getSeconds());
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
}

function formatGMTOffset(date: Date): string {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const abs = Math.abs(offsetMinutes);
  const hours = Math.floor(abs / 60);
  const minutes = abs % 60;
  return minutes === 0
    ? `GMT${sign}${hours}`
    : `GMT${sign}${hours}:${pad2(minutes)}`;
}

function pad2(value: number): string {
  return String(value).padStart(2, "0");
}
